export const selectCookieByName = (name) => {
    return (cookie) => {
        return Boolean(cookie) && cookie.trim().startsWith(`${name}=`);
    };
};
export const selectCookieDataByName = (cookie, name) => {
    if (!cookie || !name) {
        return null;
    }
    const selectedCookie = cookie.split(';').find(selectCookieByName(name));
    if (!selectedCookie) {
        return null;
    }
    return selectedCookie.split(`${name}=`)[1];
};
//# sourceMappingURL=cookie-parsing.js.map